import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiUri, filterRequest } from "../../utilities/apiManager";

let initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
}

export const getPrivacyPolicy = createAsyncThunk(
  "privacyPolicy/getPrivacyPolicy",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, query } = args;
      const filter = filterRequest(args.filter);
      const { data } = await axios.get(
        `${apiUri}/settings/privacy_policy?page=${page}&size=${size}&query=${query}${filter}`,
        {
          headers: {
            'Content-Type': 'application/json',
            "auth-token": "Bearer " + thunkApi.getState().auth.accessToken,
            "Accept-Language": document.documentElement.lang,
          }
        }
      );
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const createPrivacyPolicy = createAsyncThunk(
  "privacyPolicy/createPrivacyPolicy",
  async (args, thunkApi) => {
    try {
      const { data } = await axios.post(
        `${apiUri}/settings/privacy_policy`,
        args,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            "auth-token": "Bearer " + thunkApi.getState().auth.accessToken,
            "Accept-Language": document.documentElement.lang,
          }
        }
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const deletePrivacyPolicy = createAsyncThunk(
  "privacyPolicy/deletePrivacyPolicy",
  async (args, thunkApi) => {
    try {
      const { data } = await axios.delete(
        `${apiUri}/settings/privacy_policy/${args._id}`,
        {
          headers: {
            "auth-token": "Bearer " + thunkApi.getState().auth.accessToken,
            "Accept-Language": document.documentElement.lang,
          }
        }
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
)

const privacyPolicySlice = createSlice({
  name: "privacyPolicy",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getPrivacyPolicy.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getPrivacyPolicy.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = payload.data?.data;
        state.itemsCount = payload.data?.itemsCount;
        state.pages = payload.data?.pages;
        state.error = null;
      })
      .addCase(getPrivacyPolicy.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(createPrivacyPolicy.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createPrivacyPolicy.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.itemsCount++;
        state.data.push(payload.data);
        state.error = null;
      })
      .addCase(createPrivacyPolicy.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(deletePrivacyPolicy.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deletePrivacyPolicy.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = state.data.filter(el => el._id !== payload.data._id);
        state.error = null;
      })
      .addCase(deletePrivacyPolicy.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })
  }
});

export default privacyPolicySlice.reducer;